<template>
  <div class="container-table-datatematica">
    <q-card class="my-card">
      <q-card-section>
        <div class="row">
          <div class="col-12 container-app">
            <div class="row title-row">
              <div class="title">Datos de la temática</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-7">
            <div class="row q-col-gutter-lg input-row">
              <div class="col-12 col-lg-6">
                <q-input
                  data-cy="name-tematica"
                  v-model="name"
                  outlined
                  debounce="1000"
                  :error="v$.name.$error"
                  label="*Nombre de la temática"
                  @input="checkToSave"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                </q-input>
              </div>
              <div class="col-12 col-lg-6">
                <q-input
                  v-model="v$.displayOrder.$model"
                  outlined
                  debounce="1000"
                  :error="v$.displayOrder.$error"
                  label="*Orden"
                  type="number"
                  min="0"
                  @input="checkToSave"
                  data-cy="orden-tematica"
                >
                  <template v-slot:error>Dato obligatorio.</template>
                </q-input>
              </div>
              <div class="col-12 col-lg-6" style="min-height: 100px">
                <q-select
                  data-cy="select-vertical"
                  outlined
                  v-model="verticalSelected"
                  :options="dataVerticales"
                  option-value="id"
                  option-label="name"
                  label="Añadir al Vertical"
                  @input="checkToSave"
                />
              </div>
              <div class="col-12 col-lg-6">
                <q-input
                  data-cy="url-tematica"
                  outlined
                  debounce="1000"
                  v-model="url"
                  :error="v$.url.$error"
                  label="URL"
                  @input="checkToSave"
                >
                  <template v-slot:error>URL no válida.</template>
                </q-input>
              </div>
            </div>
          </div>
          <!-- Columna resources Logo y vídeo -->
          <div class="col-5 container-uploads">
            <div>
              <UploadImage
                data-cy="logotipo-app"
                imgDefault="img/logo-dinapsis-aplicaciones.svg"
                label="CAMBIAR LOGO"
                v-model="imgImagen"
                :showPreview="{
                  show: true,
                  sizes: {
                    width: '111px',
                    height: '108px',
                  },
                  ratio: 16 / 9,
                }"
                @input="updateLogotipo = true"
              />
            </div>
            <div class="upload-video">
              <div
                style="
                  width: 100%;
                  overflow: hidden;
                  word-wrap: break-word;
                  word-break: word;
                  text-overflow: ellipsis;
                "
              >
                {{ video ? video.name : "" }}
              </div>
              <q-file
                accept="video/mp4"
                standout
                dense
                max-files="1"
                :multiple="false"
                bg-color="primary"
                input-class="inputStyle"
                v-model="video.file"
                @input="refreshVideoInfo()"
                display-value="SUBIR VIDEO"
                :loading="isUploading"
              >
                <template v-slot:prepend>
                  <q-icon
                    class="upload-icon"
                    :name="'img:' + require('@/assets/img/upload-outline.svg')"
                  />
                </template>
              </q-file>
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { QCard, QCardSection } from 'quasar';

import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import Formats from '@/components/shared/mixins/Formats.js';
import Loading from '@/components/shared/mixins/Loading.js';
import Message from '@/components/shared/mixins/Message.js';
import Resources from '@/components/shared/mixins/Resources.js';
import UploadImage from '@/shared/uploadImage/components/UploadImage.vue';
import Validation from '@/components/shared/mixins/Validation.js';

const checkUrlOrEmpty = (url) => Validation.methods.validateURL(url) || url === '' || url === null || url === undefined;

export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    QCard,
    QCardSection,
    UploadImage
  },
  mixins: [Message, Loading, Resources, Formats],
  props: {
    dataTematica: Object,
    dataVerticales: Array
  },
  computed: {},
  validations: {
    name: { required },
    displayOrder: { required },
    url: { checkUrlOrEmpty }
  },
  data () {
    return {
      data: this.dataTematica,
      name: null,
      displayOrder: null,
      url: null,
      dataVertical: this.dataVerticales,
      verticalSelected: null,
      imgImagen: null,
      video: {
        file: null,
        name: ''
      },
      updateVideo: false,
      isUploading: false,
      updateLogotipo: false
    };
  },
  mounted () {
    this.$eventHub.$on('HAVE_ERROR', () => this.checkToSave());

    this.$eventHub.$on('EJECUCION_GUARDAR_VIDEO', ({ callback, rejected }) =>
      this.saveVideo(callback, rejected)
    );

    this.$eventHub.$on('EJECUCION_GUARDAR_LOGOTIPO', ({ callback, rejected }) =>
      this.saveLogotipo(callback, rejected)
    );
  },
  beforeDestroy () {
    this.$eventHub.$off('HAVE_ERROR');
    this.$eventHub.$off('EJECUCION_GUARDAR_VIDEO');
    this.$eventHub.$off('EJECUCION_GUARDAR_LOGOTIPO');
  },
  methods: {
    checkToSave () {
      this.v$.$touch();
      if (!this.v$.$error) {
        let name = this.name;

        if (name !== '' && name !== null && name !== undefined) {
          this.saveValues();
        }
      } else {
        this.$emit('validationError', true);
      }
    },
    async saveValues () {
      let name = this.name;
      let orden = this.displayOrder;
      let url = this.url;

      let verticalValue =
        this.verticalSelected !== null ? this.verticalSelected.id : null;

      let dataArray = {
        name: name,
        displayOrder: parseInt(orden),
        verticalId: verticalValue,
        url: url
      };

      this.$emit('saveData', dataArray);
      this.$emit('validationError', false);
    },
    async _refillData () {
      this.name = this.data.name;
      this.displayOrder = this.data.displayOrder ? this.data.displayOrder : 0;
      this.url = this.data.url;

      let resources = this.data.resources;
      let logotipo = this.searchResource(resources, 'Logotipo');
      let video = this.searchResource(resources, 'Video');

      if (logotipo !== null) {
        this.imgImagen = await this.getImgFromBase64(logotipo.url);
      }
      if (video !== null) {
        this.video.file = await this.getImgFromBase64(video.url);
        // Set new name of a video API
        this.video.name = video.originalFileName;
      }
    },
    _setVerticalSelected (idVertical) {
      let returnData = null;
      this.dataVerticales.forEach((element) => {
        if (element.id === idVertical) returnData = element;
      });
      this.verticalSelected = returnData;
    },
    async saveLogotipo (callback, rejected) {
      if (!this.updateLogotipo) return callback();

      let uploadFile = await this.saveFile('Temática', this.data.id, 'Logotipo', this.imgImagen);
      if (!uploadFile.status) { return rejected(uploadFile); }

      this.updateLogotipo = false;

      return callback(uploadFile);
    },
    refreshVideoInfo () {
      this.updateVideo = true;

      this.video.name = this.video.file.name;
    },
    async saveVideo (callback, rejected) {
      if (!this.updateVideo) return callback();
      this.isUploading = true;

      let uploadFile = await this.saveFile('Temática', this.data.id, 'Video', this.video.file);

      this.isUploading = false;

      if (!uploadFile.status) { return rejected(uploadFile); }

      this.updateVideo = false;

      return callback(uploadFile);
    }
  },
  watch: {
    dataTematica: {
      handler: function () {
        if (Object.entries(this.dataTematica).length > 0) {
          this.data = this.dataTematica;
          this._refillData();
        }
      },
      immediate: true
    },
    dataVerticales: {
      handler: function () {
        if (Object.entries(this.dataVerticales).length > 0) {
          const verticalId = this.data.verticalId;
          this._setVerticalSelected(verticalId);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table-datatematica {
  .my-card {
    min-height: 276px;
    .input-row {
      padding: 34px 0px 0px 0px;
    }
  }
  &:deep() {
    .q-table__card {
      box-shadow: none;
    }

    .q-field__messages {
      display: contents;
    }
    .q-field__counter {
      padding-left: 4px;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
  }
  .container-uploads {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    align-items: flex-end;
    padding-left: 24px;
    padding-top: 0px;

    .upload-video {
      padding-bottom: 60px;
      padding-top: 5px;
      width: 200px;

      &:deep() {
        .inputStyle {
          margin: auto;
          color: white;
          font-size: 16px;
          font-weight: bold;
        }

        .q-field__control {
          background: $seafoam-blue !important;
        }
      }

      .upload-icon {
        font-size: 24px;
        margin-left: 4px;
        filter: invert(100%) sepia(100%) saturate(38%) hue-rotate(254deg)
          brightness(110%) contrast(110%);
      }
    }
  }
}
// End UploadFile
</style>
